exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "manual-scoring .hole {\n  background-color: #2e7d32;\n  color: white;\n  text-align: center;\n  font-size: 2rem !important; }\n\nmanual-scoring .hole-index {\n  background-color: black;\n  color: white;\n  text-align: center;\n  font-size: 2rem !important; }\n\nmanual-scoring .hole-par {\n  background-color: #e6e600;\n  text-align: center;\n  font-size: 2rem !important; }\n\nmanual-scoring .scores {\n  font-size: 2rem !important;\n  text-align: center; }\n  manual-scoring .scores input {\n    width: 100%;\n    text-align: center;\n    font-weight: bold !important;\n    font-size: 2rem !important;\n    color: red !important; }\n  manual-scoring .scores input[type=number]::-webkit-inner-spin-button,\n  manual-scoring .scores input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0; }\n\nmanual-scoring .button-panel {\n  text-align: center; }\n\nmanual-scoring .ui-growl {\n  margin-top: 7em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/manual-scoring/manual-scoring.component.scss
// module id = ../../../../../src/app/component-module/manual-scoring/manual-scoring.component.scss
// module chunks = main